<template>
  
  <div>

    <!--
    <div class="jumbotron" onclick="window.location='https://view.publitas.com/dasgraphic/pistolas_oferta_publico/page/1';" :style='"background-image: url("+ imgPreUrl + banner +"x640.jpg);"'>
    </div>
    -->
    <div class="col-sm-12">
      <div class="row">
        <div class="col-md-4 banner-col">
          <div class="jumbotron best-products-jumbotron" @click="location(banner.first.url)" :style='"cursor: pointer; background-image: url("+ imgPreUrl + banner.first.photo +"x640.jpg);"'>
          </div>
        </div>

        <div class="col-md-4 banner-col">
          <div class="jumbotron best-products-jumbotron" @click="location(banner.second.url)" :style='"cursor: pointer; background-image: url("+ imgPreUrl + banner.second.photo +"x640.jpg);"'>
          </div>
        </div>

        <div class="col-md-4 banner-col">
          <div class="jumbotron best-products-jumbotron" @click="location(banner.third.url)" :style='"cursor: pointer; background-image: url("+ imgPreUrl + banner.third.photo +"x640.jpg);"'>
          </div>
        </div>
      </div>  
    </div>  

    <div class="col-sm-12 sin-costo">
      <p class="sin-costo-p">Realice su pedido online y retire sin costo en nuestras tiendas* <a href=""><strong>Ver más</strong></a></p>
    </div>
    <br>
    

   <div class="container d-none d-sm-block">
     
      <div class="best-products d-none d-sm-block" v-if="offers.length != 0">
        <h6  class="subtitle-home"><strong>Ofertas de productos </strong> <router-link to="/ofertas"> ver todo</router-link></h6> 
        <br>
        <agile ref="carousel" :arrows="false" :speed="650"
            :timing="'linear'" :fade="true"
            :autoplay="true" :pauseOnHover="false">

            <template v-if="offers.length <= 5">
              <div :class='"slide slide--x slide-products"' >
                <div class="row">
                  <div class="col-sm-6 col-md-3 col-lg-2dot4" v-for="(product_item, index) in offers" :key="index">
                    <card-template :item="product_item.productos"/>
                  </div>
                  <div class="col-sm-12"><br><br></div>
                </div>
              </div>
            </template>
            <template v-else>
              <template v-for="num in 2">
                <div :class='"slide slide--x slide-products"' v-bind:key="num" >
                  <div class="row">
                    <div class="col-sm-6 col-md-3 col-lg-2dot4" v-for="(product_item, index) in offers.slice((num*5)-5, num*5 )" :key="index">
                      <card-template :item="product_item.productos"/>
                    </div>
                    <div class="col-sm-12"><br><br></div>
                  </div>
                </div>
              </template>
            </template>
        </agile>
      </div>

      <div class="best-products d-none d-sm-block">
         <h6  class="subtitle-home"><strong>Productos sugeridos </strong> <router-link to="/productos"> ver todo</router-link></h6> 
        <br>
        <agile ref="carousel" :arrows="false" :speed="650"
            :timing="'linear'" :fade="true"
            :autoplay="true" :pauseOnHover="false">

          
            <template v-for="num in 2">
              <div :class='"slide slide--x slide-products"' v-bind:key="num" >
                <div class="row">
                  <div class="col-sm-6 col-md-3 col-lg-2dot4" v-for="(product_item, index) in bestProducts.slice((num*5)-5, num*5 )" :key="index">
                    <card-template :item="product_item"/>
                  </div>
                  <div class="col-sm-12"><br><br></div>
                </div>
                <div class="row">
                  
                </div>
              </div>
            </template>
         
     
        </agile>
      </div>


     
      
   </div>
   <div class="container d-block d-sm-none">

      <div class="best-products d-block d-sm-none" v-if="offers.length != 0">
        <h6  class="subtitle-home"><strong>Ofertas de productos </strong> <router-link to="/ofertas"> ver todo</router-link></h6> 
        <br>
        <agile ref="carousel" :arrows="false" :speed="650"
            :timing="'linear'" :fade="true"
            :autoplay="true" :pauseOnHover="false">

            
              <template v-for="(product_item, index) in offers">
                <div :class='"slide slide--x slide-products"' v-bind:key="index" >
                  <div class="row">
                    <div class="col-sm-6 col-md-3 col-lg-2dot4" :key="index">
                      <card-template :item="product_item.productos"/>
                    </div>
                    <div class="col-sm-12"><br><br></div>
                  </div>
                </div>
              </template>
            
        </agile>
      </div>

      <div class="best-products d-block d-sm-none" v-if="bestProducts.length != 0">
        <h6  class="subtitle-home"><strong>Productos sugeridos </strong> <router-link to="/ofertas"> ver todo</router-link></h6> 
        <br>
        <agile ref="carousel" :arrows="false" :speed="650"
            :timing="'linear'" :fade="true"
            :autoplay="true" :pauseOnHover="false">

             <template v-for="(product_item, index) in bestProducts">
                          <div :class='"slide slide--x slide-products"' v-bind:key="index" >
             
                  <div class="row">
                   
                             <div class="col-sm-6 col-md-3 col-lg-2dot4">
                        
                              <card-template :item="product_item"/>
                            </div>
                          
                    
                    <div class="col-sm-12"><br><br></div>
                  </div>
                </div>
            </template>
            
        </agile>
      </div>

     
   </div>
     

  </div>


</template>

<style lang="scss">

    .h1-slider{
        text-transform: uppercase;
    }
    
    .dropdown .dropdown-menu {
       border-radius:0;
    }
   
    .agile {
        
        position: relative;

        &__track {
              
        }
        
        &__arrow {
            height: 100%;
            top: 0;
            width: 80px;
            background-color: transparent;
            
            border: none;
            bottom: -11px;
            margin: 0;
            padding: 0;
            position: absolute;
            transition-duration: .3s;

            &:hover {
                background-color: rgba(#000, .5);
                #arrow-svg {
                fill: #fff;
                }
            }

            &[disabled] {
            display: none;
            }

            #arrow-svg {
            fill: rgba(#fff, .4);
            height: 25px;
            }
            
            &--prev {
                left: 0;
            }

            &--next {
                right: 0;
            }

            

            svg {
                fill: #888;
                height: 24px;
                transition-duration: .3s;
            }
        }

        &__dots {
            /*
            align-items: center;
            display: flex;
            justify-content: center;
            list-style: none;
            margin: 20px 0;
            padding: 0;
            text-align: center;
            white-space: nowrap;
            */
            bottom: 5%;
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
        }

        &__dot {

            button {
                opacity: 0.4;
                background-color: grey;
                border: 1px solid grey;
                border-radius: 50%;
                cursor: pointer;
                display: block;
                height: 14px;
                margin: 10px;

                &:hover {
                    background-color: grey;
                }
            }

            &--current {
            button {
                background-color: #fff;
            }
        }
        }

        .slide{
            
            background: {
                position: center;
                size: cover;
            }

            height: auto !important;

            &:before {
                background-color: rgba(#000, .2);
                content: '';
                height: 100%;
                left: 0;
                position: absolute;
                top: 0;
                width: 100%;
            }

        }

        .slide-products{
           background: {
                position: center;
                size: cover;
            }

            height: auto !important;

            &:before {
                background-color: white;
                content: '';
                height: 100%;
                left: 0;
                position: absolute;
                top: 0;
                width: 100%;
            }
        }
    }
</style>


<script>
import axios from "axios";
import { errorToaster } from "../shared/service/ErrorHandler";
import CardLoader from "../shared/CardLoaderHome";
import CardTemplate from "../shared/CardTemplate";
import Carrousel from "@/components/slider/Carrousel.vue"
import {config_settings} from '../../config.js';

export default {
  name: "BestProducts",
  components: { CardLoader, CardTemplate, Carrousel },
  props:  ["banner"],
  data() {
    return {
      bestProducts: [],
      offers: [],
      loading: false,
      imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
    };
  },
  methods: {

  //manadatory function called from cardTemplate 
    getBestProducts() {
      this.loading = true;
      axios.get(config_settings.RESOURCE_SERVER_URL + '/GET/catalog/products')
           .then(response => {
              this.loading = false;
              this.bestProducts = response.data.products;
           })
           .catch(error => {
              console.log(error);
              errorToaster("The server encountered an unexpected condition.","Internal Error 500");
           });
    },

    getOffers() {
      this.loading = true;
      axios.get(config_settings.RESOURCE_SERVER_URL + '/GET/catalog/products/offers')
           .then(response => {
              this.loading = false;
              this.offers = response.data.offer;
              console.log(this.offers)
           })
           .catch(error => {
              console.log(error);
             // errorToaster("The server encountered an unexpected condition.","Internal Error 500");
           });
    },

    location(url) {
      window.location = url
    }
  },
  created() {
    this.getBestProducts();
    this.getOffers()
  }
};
</script>

<style>
.best-products {
  margin-bottom: 10px;
}

.jumbotron {
  background-size: 100% 100%;
  border-radius: .0rem;
}

.banner-col {
  padding: 0;
}


.sin-costo {
  background-color: #1f364c;
}

.sin-costo-p {
  color: white;
  padding: 7px;
  font-size: 14px;
}

/*
.jumbotron{
  background-size: cover;
}
*/

</style>
